export default __webpack_public_path__ + "static/B0088-2a1227b248d560877559be7766afbb88.png";